export default {
  GET_CONTACT_INFO: "GET_CONTACT_INFO",
};
